import React from "react";
import { Card } from "react-bootstrap";
import fallbackImage from '../images/profileImage.jpg';
import Bar from '../images/barChart.png';

// null/undefined means no applicable work in the period, so show N/A rather than 0%
export const formatPerformance = (value) => {
    const number = Number(value);
    return value === null || value === undefined || value === "" || !Number.isFinite(number) ? "N/A" : number.toFixed(2) + "%";
};

const EmployeeCard = ({employeeID, image, name, percentage}) =>{
    return <Card className="p-2 d-flex flex-row align-items-center border-radius-10 shadow">
        <Card.Img variant="left" width={70} height={70} src={image? "data:image/jpeg;base64,"+ image : fallbackImage} style={{borderRadius: '12px'}}/>
        {/* minWidth 0 lets a long name truncate with an ellipsis instead of overflowing the card */}
        <Card.Body className="p-0 pl-3 py-1" style={{minWidth: 0}}>
            <Card.Title className="text-truncate mb-1" style={{fontSize: 14, fontWeight: 400}} title={name}>{name}</Card.Title>
            {employeeID && <Card.Text className="text-muted mb-1" style={{fontSize: 12}}>{employeeID}</Card.Text>}
            <Card.Text className="mb-0" style={{fontSize: 13}}>
                <Card.Img variant="left" width={16} height={16} src={Bar}/>
                {' '}{formatPerformance(percentage)}
            </Card.Text>
        </Card.Body>
    </Card>
}

export default EmployeeCard;